import { LabelProps } from "./Label.types";
import { useClassNames } from "../../../structure";

export default function Label({ id, color, children, type = "l2Regular", classNames = [], fitContent }: LabelProps) {
  const style = useClassNames([type, ...classNames]);

  return (
    <label
      id={id}
      style={{
        ...style,
        boxSizing: "border-box",
        ...(color ? { color } : {}),
        cursor: "inherit",
        ...(fitContent ? { width: "fit-content" } : {}),
      }}
    >
      {children}
    </label>
  );
}
